import React from 'react';
import { Box, Typography } from '@mui/material';
import { formatMessageTimestamp } from '../../../../../utils/formatTime';
import { MAX_UNREAD_MESSAGE_COUNT } from '../../../../../constants/commonConstants';
import { IEventDetailMessages } from '../../../../../types/eventTypes';
import MentionBadge from '../../../../SendBird/MentionBadge/MentionBadge';
import { shouldShowMentionBadge } from '../../../../../utils/sendbird/chatAccessibility';
import './MessageListItem.scss';

interface IMessageListItemProps {
  message: IEventDetailMessages;
  customerFirstLastName: string;
  eventName: string;
  customerName: string;
  onClick?: (messageId: string) => void;
}

const MessageListItem: React.FC<IMessageListItemProps> = ({
  message,
  customerFirstLastName,
  eventName,
  customerName,
  onClick,
}) => {
  const handleClick = () => {
    if (onClick) {
      onClick(message.vendorEventId);
    }
  };

  const renderUnreadBadge = () => {
    if (!message.unreadMessageCount || message.unreadMessageCount === 0) {
      return null;
    }

    return (
      <Box className="messageUnreadBadge">
        <Typography className="messageUnreadBadgeText">
          {message.unreadMessageCount > MAX_UNREAD_MESSAGE_COUNT ? `${MAX_UNREAD_MESSAGE_COUNT}+` : message.unreadMessageCount}
        </Typography>
      </Box>
    );
  };

  return (
    <Box
      className={`messageListItemB2C ${message.unreadMessageCount ? 'unread' : ''}`}
      onClick={handleClick}
    >
      <Box className="messageListItemContainer">
        <Box className="messageAvatarMargin">
          <Box className="messageAvatarBackground" sx={{ backgroundColor: message.logoBackgroundColor }}>
            <Box className="messageAvatarInner">
              <Typography className="messageAvatarText">
                {customerFirstLastName}
              </Typography>
            </Box>
          </Box>
        </Box>
        <Box className="messageContentContainer">
          <Box className="messageHeaderContainer">
            <Box className="messageVendorNameContainer">
              <Typography className={`messageVendorName ${!message.lastMessage ? 'startChat' : ''}`}>
                {eventName}
              </Typography>
            </Box>
            <Box className="messageTimestampContainer">
              <Typography className="messageTimestamp">
                {message.lastMessageAt ? formatMessageTimestamp(message.lastMessageAt) : ''}
              </Typography>
            </Box>
          </Box>
          <Box className="messagePreviewContainer">
            <Box className="messageTextContainer">
              <Typography className={`messagePreviewText ${!message.lastMessage ? 'startChat' : ''}`}>
                {message.lastMessage || `Tap to chat with ${customerName}`}
              </Typography>
            </Box>
            <Box className="messageRowBadges">
              {shouldShowMentionBadge(message) ? <MentionBadge /> : null}
              {renderUnreadBadge()}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default MessageListItem;
